module.exports = __webpack_public_path__ + "img/pile28802.76b7def3.png";